/* 
  web端-教师
*/
import request from "@/utils/request";
let baseUrl1 = window.config.baseUrl4WebTeacher  // 梁江辉接口地址1
let baseUrl2 = window.config.baseUrl4Shool  // 飞泉接口地址online

/**----------------------- web端 教师专家报名接口  -------------------------------- */
//查看教师详情信息
export function getTeacherDetailInfo() {
  return request({
    url: baseUrl1+"/teacher/signuUp/getTeacherDetailInfo",
    method: "get",
  });
}
// /teacher/signuUp/getSource 获取报名类型
export function getSource(projectId) {
  return request({
    url: baseUrl1+"/teacher/signuUp/getSource",
    method: "get",
    params:{projectId}
  });
}
/*
    /teacher/signuUp/getTchOtherInfo 获取教师其他信息
     projectId -- 项目id
     sourceId -- 报名类型id
*/ 
export function getTchOtherInfo(projectId,sourceId) {
  return request({
    url: baseUrl1+"/teacher/signuUp/getTchOtherInfo",
    method: "get",
    params:{
      projectId,
      sourceId
    }
  });
}

//   /teacher/signuUp/save  保存
export function save(data) {
  return request({
    url: baseUrl1+"/teacher/signuUp/save",
    method: "post",
    data
  });
}
//专家报名
export function signUp(data) {
  return request({
    url: baseUrl1+"/teacher/signUp",
    method: "post",
    data
  });
}

//发消息
export function saveSendInfo(data) {
  return request({
    url: "/teacher/saveSendInfo",
    method: "post",
    data
  });
}


/**------------------------ web端 教师聘用信息  ------------------------------------ */

//  /teacher/employ/getEmployInfo 获取聘用信息分页列表

export function getEmployInfo(params) {
  return request({
    url: baseUrl1+"/teacher/employ/getEmployInfo",
    method: "get",
    params
  });
}

// 打印聘书 /teacher/employ/downloadContract

export function downloadContract(data) {
  return request({
    url: baseUrl1+ `/teacher/employ/downloadContract`,
    method: "post",
    responseType: 'blob',
    data
  });
}

// 打印优秀证书 /teacher/employ/downloadCertificate

export function downloadCertificate(data) {
  return request({
    url: baseUrl1+ `/teacher/employ/downloadCertificate`,
    method: "post",
    responseType: 'blob',
    data
  });
}

/**--------------------  通知消息   ----------------------------- */

//通知消息 /teacher/msg/getReceiveInfo

export function getReceiveInfo(params) {
  return request({
    url: baseUrl1+ "/teacher/msg/getReceiveInfo",
    method: "get",
    params
  });
}